import { createContext, useContext, useState } from 'react';

export const CaregiverFormContext = createContext({
  invalidFields: {},
  setInvalidFields: () => {},
  addressData: { bscAddr: '', dtlAddr: '', postNo: '' },
  setAddressData: () => {},
  accompaniment: '',
  setAccompaniment: () => {},
});

export const CaregiverFormProvider = ({ children }) => {
  const [invalidFields, setInvalidFields] = useState({
    birth: false,
    tel: [false],
  });
  const [addressData, setAddressData] = useState({ bscAddr: '', dtlAddr: '', postNo: '' });
  const [accompaniment, setAccompaniment] = useState('');

  return (
    <CaregiverFormContext.Provider
      value={{ invalidFields, setInvalidFields, addressData, setAddressData, accompaniment, setAccompaniment }}
    >
      {children}
    </CaregiverFormContext.Provider>
  );
};

export const useCaregiverFormContext = () => {
  const context = useContext(CaregiverFormContext);
  if (!context) {
    throw new Error('useFiledContext must be used within a CaregiverFormProvider');
  }
  return context;
};
